// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  GridColDef,
  GridRowId,
  GridRenderCellParams,
  GridActionsCellItem,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { DeleteConfirmModal, Table } from "../../molecules";
import { Loading, StatusBar } from "../../atoms";
import {
  IMemberVPos,
  PagingResponse,
  useAuthorization,
  useGetMemberVPosList,
} from "../../../hooks";
import React from "react";
import { DeleteMemberVPosRequest, useMemberVPosDelete } from "../../../hooks";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";
import dayjs from "dayjs";

function RenderStatus(props: GridRenderCellParams<any, string>) {
  const { value } = props;

  return <>{value && <StatusBar status={value} />}</>;
}

type BankListingTableProps = {
  onRowClick?: (data: { id: GridRowId; row: any }) => void;
};

export const BankListingPassiveTable = ({
  onRowClick,
}: BankListingTableProps) => {
  const theme = useTheme();
  const {showDelete, showUpdate} = useAuthorization();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [queryOptions, setQueryOptions] = React.useState({});
  const [tableData, setTableData] =
    useState<PagingResponse<Array<IMemberVPos>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const { mutate: getMemberVPosList, isLoading } = useGetMemberVPosList();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const { mutate: memberVPosDelete, isLoading: isDeleteLoading } =
    useMemberVPosDelete();
  const setSnackbar = useSetSnackBar();

  useEffect(() => {
    const savedFilter = localStorage.getItem("bankListPassiveTabFilter");
    if (savedFilter) {
      setQueryOptions(JSON.parse(savedFilter));
    }
  }, []);

  useEffect(() => {

    const requestPayload = {
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      status: "PASSIVE",
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }


    getMemberVPosList(
    requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  }, [
    getMemberVPosList,
    paginationModel.page,
    paginationModel.pageSize,
    setSnackbar,
    queryOptions
  ]);

  const deleteRow = React.useCallback(
    (memberVPos: IMemberVPos) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(Number(memberVPos.id));
    },
    []
  );

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteMemberVPosRequest = { id: selectedRowId };

    memberVPosDelete(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          getMemberVPosList({
            size: paginationModel.pageSize,
            page: paginationModel.page <= 0 ? 0 : paginationModel.page,
            orderBy: "CreateDate",
            orderByDesc: true,
            status: "PASSIVE",
          },
          {
            onSuccess: (data) => {
              if (data.isSuccess) {
                setTableData(data?.data);
              } else {
                setTableData(data?.data);
                setSnackbar({
                  severity: "error",
                  description: data.message,
                  isOpen: true,
                });
              }
            },
            onError: () => {
              setSnackbar({
                severity: "error",
                description: "İşlem sırasında bir hata oluştu",
                isOpen: true,
              });
            },
          });
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);

    getMemberVPosList(
      {
        size: paginationModel.pageSize,
        page: paginationModel.page,
        orderBy: "CreateDate",
        orderByDesc: true,
        status: "PASSIVE",
      },
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "update",
        type: "actions",
        width: 80,
        getActions: (params) => {
          return [
            !!showDelete ? <GridActionsCellItem
              label="Sil"
              onClick={deleteRow(params.row)}
              showInMenu
            /> : <></>,
          ];
        },
      },
      { field: "bankName", headerName: "Banka Adı", width: 400 },
      {
        field: "createDate",
        headerName: "Oluşturma Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      { field: "createUserName", headerName: "Oluşturan Kullanıcı", width: 200 },
      {
        field: "updateDate",
        headerName: "Son Güncellenme Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      { field: "updateUserName", headerName: "Son Güncelleyen Kullanıcı", width: 200 },
      {
        renderCell: RenderStatus,
        field: "status",
        headerName: "Durum",
        width: 100,
        filterable: false
      },
    ];
  }, [deleteRow, showDelete]);

  const onSave = () => {

    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      status: "PASSIVE",
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }
    getMemberVPosList(
   requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                return {
                  "Banka Adı": item?.bankName,
                  "Oluşturma Tarihi": item?.createDate,
                  "Oluşturan Kullanıcı": item?.createUserName,
                  "Son Güncellenme Tarihi":item?.updateDate,
                  "Son Güncelleyen Kullanıcı":item?.updateUserName,
                  "Durum": item?.status,
                  "Varsayılan Banka": item?.defaultBank
                };
              });
            }
            const refactoredData = fieldValue(data?.data?.result);
            downloadExcel(refactoredData|| [], "Pasif Banka Listesi");
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      localStorage.removeItem("bankListPassiveTabFilter");
      return setQueryOptions({});
    }
  
    const queryParams = getQueryParams(filters);
    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);
    
    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;
  
    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }
  
    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
      localStorage.setItem('bankListPassiveTabFilter', JSON.stringify(queryParams))
    }
  
    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;
  
  }, 500);
  
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});

  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;

  const hasLoading = isLoading || isDeleteLoading;
  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} py={2}>
      <>
    <Table
     columnVisibilityConfigKey="bankListtingPassiveTabColumnVisibilityKey"
        filterKey="bankListPassiveTabFilter"
        hasActiveFilters={hasActiveFilters}
        handleFilterChange={handleFilterChange}
        paginationModel={paginationModel}
        onPaginationModelChange={handleChangePagination}
        paginationMode="server"
        rowCount={tableData?.totalItems || 0}
        onRowClick={onRowClick}
        sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
        isRowSelectable={() => false}
        // disableColumnMenu
        rows={
            (Array.isArray(tableData?.result) ? tableData.result : []) 
            .filter((item) => item.status === "PASSIVE")
        }
        getRowClassName={(params) => {
            if (params.row.status === 'PASSIVE') return 'pasive-row';
            if (params.row.status === 'BLOCKED') return 'blocked-row';
            return '';
        }}
        columns={columns}
        exportFileName="Pasif Banka Listesi"
        onSave={() => onSave()}
    />
    <DeleteConfirmModal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={() => handleDeleteConfirm()}
    ></DeleteConfirmModal>
</>
      </Stack>
    </>
  );
};
